import type {AppStoreButton} from '../../../../../schemas/contentful/contentTypes/appStoreButton'
import {AppleAppStore} from './AppleAppStore'
import {GooglePlayStore} from './GooglePlayStore'

type MobileAppStoreProps = {
  component: AppStoreButton
}

const mobileStoreButtonComponents = {
  Android: GooglePlayStore,
  iOS: AppleAppStore,
}

export const MobileAppStoreLink: React.FunctionComponent<MobileAppStoreProps> = ({component}) => {
  const MobileStoreButtonComponent = mobileStoreButtonComponents[component.fields.storeOs]

  return <MobileStoreButtonComponent link={component.fields.link} key={component.sys.id} />
}

try{ MobileAppStoreLink.displayName ||= 'MobileAppStoreLink' } catch {}